<template>
  <div class="share--catalog-container" v-show="user">
    <button class="btn btn-primary" @click="generateLink">
      <v-icon class="mr-2">mdi-star</v-icon>
      <span>{{ $t('general.generateReviewLink') }}</span>
      <popover v-show="copyLinkSucceeded"></popover>
    </button>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import Popover from '@/components/utils/popover.vue';

export default {
  components: { Popover },
  props: [],
  data() {
    return {
      loading: false,
      copyLinkSucceeded: false,
    };
  },
  computed: {
    ...mapState({
      user: (state) => state.global.user,
    }),
    ...mapGetters({}),
  },
  async mounted() {},
  methods: {
    async generateLink() {
      if (!this.loading) {
        try {
          this.loading = true;
          const url = await this.$store.dispatch('profile/getReviewLink');
          console.log('Generated review link: ', url);
          await navigator.clipboard.writeText(url);
          await this.handleCopyLinkStatus(true);
          // eslint-disable-next-line no-empty
        } catch (e) {}
      }
    },
    async handleCopyLinkStatus(status) {
      this.copyLinkSucceeded = status;
      let self = this;
      setTimeout(() => {
        self.copyLinkSucceeded = false;
        this.loading = false;
      }, 2000);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../assets/scss/utils/variables';
.share--catalog-container {
  min-width: 33%;
  position: relative;
  @media #{$phones} {
    width: 100% !important;
  }

  .btn {
    position: relative;
    width: 300px;
    @media #{$phones} {
      width: 100%;
    }
  }
}
</style>
